export var PcidDic;
(function (PcidDic) {
    // app导流渠道号
    PcidDic["Apps"] = "om01,om02,om06,om07";
    PcidDic["FromSearch"] = "om01";
    PcidDic["FromPaly"] = "om02";
    PcidDic["FromPalyMore"] = "om06";
    PcidDic["FromVideoPlay"] = "om07";
    PcidDic["OppoThemes"] = "ot01,ot02,ot03,ot04";
})(PcidDic || (PcidDic = {}));
export const PcidType = {
    Apps: PcidDic.Apps,
    FromSearch: PcidDic.FromSearch,
    FromPaly: PcidDic.FromPaly,
    FromPalyMore: PcidDic.FromPalyMore,
    FromVideoPlay: PcidDic.FromVideoPlay,
    OppoThemes: PcidDic.OppoThemes
};
